module.exports = __webpack_public_path__ + "media/images/plans/img_simple-wedding-ee9a22c0d302b83930481b6b3916fe07.jpg";